import React from "react";

function NotFound() {
	return <h1 style={{ margin: "20px" }}>Invalid URL!</h1>;
}

export default NotFound;
